import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { PartListFactoryImpl } from "./PartsListFactoryImpl.tsx";
import { PartsListItems } from "./parts-list-content.component.tsx";

export interface PartsListInterface {
    title?: string;
    mt?: number;
    items: PartsListItems[];
}

export const PartsList: React.FC<PartsListInterface> = ({ title, mt, items }) => {
    const factory = new PartListFactoryImpl();
    return (
        <Container className={mt ? `pt-${mt}` : undefined}>
            {title && (
                <Row>
                    <Col className="text-uppercase bg-theme-ternary fw-bold p-3">
                        {title}
                    </Col>
                </Row>
            )}
            {factory.create(items)}
        </Container>
    );
}
